<section class="full-height flex flex--vertical">
  <div class="logo-container">
    <!-- TODO: Add logo? -->
  </div>

  <div class="intro">
    <h1>Error 404: This is not the page you're looking for</h1>
  </div>
</section>
